import { render, staticRenderFns } from "./ReactMountEtapaProducao.vue?vue&type=template&id=748080f2"
import script from "./ReactMountEtapaProducao.vue?vue&type=script&lang=ts"
export * from "./ReactMountEtapaProducao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('748080f2')) {
      api.createRecord('748080f2', component.options)
    } else {
      api.reload('748080f2', component.options)
    }
    module.hot.accept("./ReactMountEtapaProducao.vue?vue&type=template&id=748080f2", function () {
      api.rerender('748080f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/ReactMountEtapaProducao.vue"
export default component.exports